import rootReducer from "./Reducer/index";
// import { createStore } from 'redux';
import { configureStore } from '@reduxjs/toolkit';


const store = configureStore({
    reducer: rootReducer,
  });
  
  // Type exports
  export type RootState = ReturnType<typeof store.getState>;
  export type AppDispatch = typeof store.dispatch;
  
  export default store;